// src/features/onboarding/utils/media-url.ts
const baseUrl = import.meta.env["VITE_R2_PUBLIC_BASE_URL"];

export function libraryItemUrl(item: any): string | undefined {
  const url = item?.file?.fileUrl;
  if (!url) return undefined;
  if (url.startsWith("http")) return url;
  return `${baseUrl}/${url}`;
}

export function mediaUrl(url?: string | null): string | undefined {
  if (!url) return undefined;
  if (url.startsWith("http")) return url;
  return `${baseUrl}/${url}`;
}